import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface NewReleaseMultiProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const NewReleaseMulti: React.FunctionComponent<React.PropsWithChildren<NewReleaseMultiProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}: NewReleaseMultiProps) => (
    <SVGBase viewBox="0 0 49.95 49.85" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            fill="#ebadff"
            d="M17.16,14.46a.65.65,0,0,0-.65-.65H.65a.65.65,0,0,0-.65.65V49.2a.65.65,0,0,0,.65.65H5.31v-9a.58.58,0,0,1,.58-.57h5.38a.58.58,0,0,1,.58.57v9h5.31V14.46ZM7.49,34.6a.55.55,0,0,1-.55.55H3.35a.55.55,0,0,1-.55-.55V31a.55.55,0,0,1,.55-.55H6.94a.55.55,0,0,1,.55.55Zm0-7a.55.55,0,0,1-.55.55H3.35a.55.55,0,0,1-.55-.55V24a.55.55,0,0,1,.55-.55H6.94a.55.55,0,0,1,.55.55Zm0-7a.54.54,0,0,1-.55.55H3.35a.54.54,0,0,1-.55-.55V16.94a.55.55,0,0,1,.55-.56H6.94a.55.55,0,0,1,.55.56Zm7,14.05a.55.55,0,0,1-.55.55h-3.6a.55.55,0,0,1-.55-.55V31a.55.55,0,0,1,.55-.55H14a.55.55,0,0,1,.55.55Zm0-7a.55.55,0,0,1-.55.55h-3.6a.55.55,0,0,1-.55-.55V24a.55.55,0,0,1,.55-.55H14a.55.55,0,0,1,.55.55Zm0-7a.55.55,0,0,1-.55.55h-3.6a.55.55,0,0,1-.55-.55V16.94a.56.56,0,0,1,.55-.56H14a.56.56,0,0,1,.55.56Z"
        />
        <path
            fill="#f5dcff"
            d="M33.66,25.93H17.16V49.85H34.31V26.58A.65.65,0,0,0,33.66,25.93ZM24.57,34.6a.55.55,0,0,1-.55.55h-3.6a.55.55,0,0,1-.55-.55V31a.55.55,0,0,1,.55-.55H24a.55.55,0,0,1,.55.55Zm7,7a.56.56,0,0,1-.55.56h-3.6a.56.56,0,0,1-.55-.56V38a.55.55,0,0,1,.55-.55h3.6a.55.55,0,0,1,.55.55Zm0-7a.55.55,0,0,1-.55.55h-3.6a.55.55,0,0,1-.55-.55V31a.55.55,0,0,1,.55-.55h3.6a.55.55,0,0,1,.55.55Z"
        />
        <rect fill="#f5dcff" x="2.8" y="16.38" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#f5dcff" x="9.82" y="16.38" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#f5dcff" x="2.8" y="23.41" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#f5dcff" x="9.82" y="23.41" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#f5dcff" x="2.8" y="30.43" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#f5dcff" x="9.82" y="30.43" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#ebadff" x="19.87" y="30.43" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#ebadff" x="26.9" y="30.43" width="4.7" height="4.72" rx="0.55" />
        <rect fill="#ebadff" x="26.9" y="37.46" width="4.7" height="4.72" rx="0.55" />
        <path fill="#f5dcff" d="M11.27,40.25H5.89a.58.58,0,0,0-.58.57v9h6.54v-9A.58.58,0,0,0,11.27,40.25Z" />
        <path
            fill="#ebadff"
            d="M39,0A10.95,10.95,0,1,0,50,11,10.95,10.95,0,0,0,39,0Zm5.08,11.94H40V16a1,1,0,0,1-2,0V11.94H33.92a1,1,0,1,1,0-2H38V5.86a1,1,0,0,1,2,0V10h4.08a1,1,0,1,1,0,2Z"
        />
        <path
            fill="#fff"
            d="M44.08,10H40V5.86a1,1,0,0,0-2,0V10H33.92a1,1,0,1,0,0,2H38V16a1,1,0,0,0,2,0V11.94h4.08a1,1,0,1,0,0-2Z"
        />
    </SVGBase>
);

export default NewReleaseMulti;
